import request from "./request.js"

const apiBase = '2023-benq-upload-files';
export const uploadImage = params => request.post(apiBase, params);
export const totalImage = () =>  request.get(`${apiBase}/count`);
export const listImage = params => request.get(apiBase, params);